import { Component, OnInit, ViewChild, EventEmitter, Output, Input, ChangeDetectionStrategy } from '@angular/core';
import { SelectItem } from 'primeng/components/common/selectitem';
import { Table } from 'primeng/table';
import { ViewType } from '@framework/core/Enums';
import { IControlChangeEventArgs } from '@common/formbuilder/IControlChangeEventArgs';
import { IColumnOptions, IDataEndPoint } from '@framework/interfaces/IEntity';
import { ApiService } from '@services/api/api.service';
import { NbToastrService } from '@nebular/theme';
import { IPropertyFilter } from '../../../common/formbuilder/PropertyFilter';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';

@Component({
  selector: 'app-mf-table',
  templateUrl: './mf-table.component.html',
  styleUrls: ['./mf-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush //manaul change detection, huge speed improvement
})
export class MfTableComponent implements OnInit {
  @Input() public lazyLoad: boolean = false;
  @Input() public parent: any;
  @Input() public loading: boolean = false;
  @Input() public data: any[];
  @Input() public filterCount: number;
  @Input() public metadataTemplateItems: any;
  @Input() public rows: any = 50;
  @Input() public lazy: any = true;
  @Input() public scrollable: any = true;
  @Input() public virtualScroll: any = true;
  @Input() public columnsChangeRequireApiCall: boolean = true;
  @Input() public limitNumCharsEnabled: boolean = true;
  @Input() public limitNumChars: number = 60;
  @Input() public canDelete: boolean = false;
  @Input() public showFilterCol: boolean = true;
  @Input() public staticFilters: Array<IPropertyFilter>;
  @Input() public grouped: boolean = false;
  @Input() public rowGroupMetadata: any;
  @Input() public groupingField: string = 'id';
  @Input() public expandedRowKeys: any = {};
  @Input() public autoSizeColumns: boolean = true;
  @Input() public rowGroupMetadataActions: any;
  @Input() public grandTotal: any;
  @Input() public formReadOnly: boolean;

  @Input() public set selectedColumns(value) {
    this._selectedColumns = value;
    this.reloadTable();
    this.selectedVisibleColumns = this.selectedColumns.filter(o => typeof (o.visible) == 'undefined' || o.visible);
  }
  @Input() public set selectedmetadataTemplateItems(value) {
    this._selectedmetadataTemplateItems = value;
    this.selectedmetadataTemplateItemsChange.emit(value);
  }
  @Input() public set selectedItem(value) {
    this._selectedItem = value;
    this.selectedItemChange.emit(value);
  }

  @Output() public onLoadItems: EventEmitter<any> = new EventEmitter();
  @Output() public selectedmetadataTemplateItemsChange = new EventEmitter();
  @Output() public selectedItemChange = new EventEmitter();
  @Output() public staticFiltersChange = new EventEmitter();
  @Output() public onDeleteItem = new EventEmitter();
  @Output() public onPageEvent = new EventEmitter();
  @Output() public onSortEvent = new EventEmitter();






  @ViewChild('dt', { static: true }) dt: Table;
  public selectedVisibleColumns: any;
  private _selectedmetadataTemplateItems: any[];
  private _selectedItem: any = {};
  private _columns: any[] = [];
  private _selectedColumns: any[];
  public _currentFilterObject: any;
  public showFilters: boolean = true;

  public staticColumns: any[];
  public columns: SelectItem[];
  public filters: any = {};
  public viewType = ViewType;

  public advancedFilters: any[] = [];
  public constructor(private apiService: ApiService, private messageService: NbToastrService, private authService: IdentityAuthService) { }

  public ngOnInit() {
  }


  @Output() public onControlDataChange = new EventEmitter<IControlChangeEventArgs>();
  public get selectedmetadataTemplateItems() {
    return this._selectedmetadataTemplateItems;
  }
  public get selectedColumns() {
    return this._selectedColumns;
  }

  public get selectedItem() {
    return this._selectedItem;
  }

  public reloadTable() {
    if (this.dt) {
      var arr = new Array();

      this._currentFilterObject = null;
      //if (this.lazyLoad)
      this.dt.onLazyLoad.emit(this.dt.createLazyLoadMetadata());
    }
  }

  public loadItems(event) {
    if (!this.selectedColumns)
      return;
    let filterArr = new Array();

    if (event.filters) {
      for (let key in event.filters) {
        var col;
        var cols = this._selectedColumns.filter(o => o.field == key);
        if (cols.length > 0)
          col = cols[0];
        var val = event.filters[key].value;
        if (typeof val === 'object') {
          val = JSON.stringify(val)
        }
        filterArr.push({ columnName: key, filterValue: val, whereFilterType: col.whereFilterType, whereExpressionType: col.whereExpressionType })
      }
    }
    if (this.staticFilters)
      this.staticFilters.filter(function (o) {
        return o.filterValue != '' && o.filterValue != null
      })
        .forEach(o => {
          filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
        });
    let filterObject = {
      StartCount: event.first,
      PageSize: this.rows,
      Filters: filterArr,
      Sort: { key: event.sortField, Type: event.sortOrder },
      SelectedColumns: !this.selectedColumns ? null : this.selectedColumns.map(({ field }) => field)
    };
    if (this._currentFilterObject && this._currentFilterObject == JSON.stringify(filterObject)) {
      return;
    }

    this._currentFilterObject = JSON.stringify(filterObject);
    this.onLoadItems.emit(filterObject);
  }

  public limitNumberOfChars(val: string) {
    if (!this.limitNumCharsEnabled)
      return val;
    if (val && val.length > this.limitNumChars)
      return val.substring(0, this.limitNumChars) + "...";
    else return val;
  }

  public controlDataChange(value: IControlChangeEventArgs) {
    this.onControlDataChange.emit(value);
  }

  public toggleShowFilters(event) {
    this.showFilters = !this.showFilters;
    event.stopPropagation();
    if (!this.showFilters)
      this.dt.reset()
  }

  public selectAllChange(col: IColumnOptions, value: boolean) {
    event.stopPropagation();
    if (typeof value != "undefined") {
      if (col.selectAllEndPoints) {
        let endPoint: IDataEndPoint = (col.selectAllEndPoints.insert && value) ? col.selectAllEndPoints.insert : (col.selectAllEndPoints.delete && !value) ? col.selectAllEndPoints.delete : null;
        if (endPoint) {
          let self: MfTableComponent = this;
          self.apiService.exec({
            endPoint: endPoint,
            context: self,
            success: function (data) {
              self.messageService.success('Successfully saved', 'Action');
              self.data.forEach(item => {
                item[col.field] = value;
              })
            },
            error: function (error) {
              self.loading = false;
              self.messageService.danger('Could not save', 'Action');
            }
          })
        }
      }
    }
  }

  public delete(event, rec) {
    this.onDeleteItem.emit(rec);
  }

  public onPage() {
    this.onPageEvent.emit();
  }

  onSort() {

    this.onSortEvent.emit();
  }


  public filterDataChanged(col) {
    //, col.whereExpressionType
    this.dt.filter(this.filters[col.dbField], col.field, col.filterMatchMode)
  }

  public clearFilters() {
    this.filters = new Array();
    this.dt.reset()
  }

  public getGroupItems(group) {
    var arr = new Array();
    var curIndex = group.index;
    while (curIndex < (group.index + group.size)) {
      arr.push(this.data[curIndex++])
    }
    return arr;
  }

  public isActionHidden(action) {
    if (action.visible)
      return !action.visible(this)
    else return false;
  }


}
